import React from 'react';

import { stepTypes } from '../../actions/IdVerificationActions';

import IdCard from '../../components/idverification/idcard/IdCard';
import Photo from '../../components/idverification/photo/Photo';

function mapStateToProps(state) {
    /**
     * As the ID photo capture is only required the first time the test is run,
     * while the face photo capture is required in all cases, I prefer to set
     * the face step as the default.
     */
    const stepElement = (
        (state.idverification.currentStep === stepTypes.ID_CARD)
            ? <IdCard />
            : <Photo />
    );

    return { stepElement };
}

export default mapStateToProps;
